/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    clearFormatQas, clearAddressQas, flagMFEQasFailed,
    flagOffShowValidatedQAS, flagOnShowValidatedQAS,
    loadFormatQas, loadAddressQas, resetQasState,
    setUnverifiedFlowActive,
} from './AddressQAS-Actions';

const initialQASAddresState =  {
    suggestions: {},
    formatAddress: {},
    showValidatedAddress: false,
    qasFailed: false,
    isUnverifiedFlowActive: false,
};

const qasAddressSearch = (state = initialQASAddresState, action) => {
    switch (action.type) {
        case loadAddressQas().type:
            return {
                ...state,
                suggestions: action.data,
            };
        case clearAddressQas().type:
            return {
                ...state,
                suggestions: {},
            };
        case loadFormatQas().type:
            return {
                ...state,
                formatAddress: action.data,
            };
        case clearFormatQas().type:
            return {
                ...state,
                formatAddress: {},
            };
        case flagOnShowValidatedQAS().type:
            return {
                ...state,
                showValidatedAddress: true,
            };
        case flagOffShowValidatedQAS().type:
            return {
                ...state,
                showValidatedAddress: false,
            };
        case resetQasState().type:
            return {
                ...state,
                suggestions: {},
                formatAddress: {},
                showValidatedAddress: false,
            };
        case flagMFEQasFailed().type:
            return {
                ...state,
                qasFailed: action.data,
            };
        case setUnverifiedFlowActive().type:
            return {
                ...state,
                isUnverifiedFlowActive: action.data,
            };
        default:
            return state;
    }
};

export default qasAddressSearch;
